import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {Switch,Typography,Grid} from '@material-ui/core';

const useStyles = makeStyles({
    root:{
        background:'#212121'
    },
    TypographyRoot:{
        color:'white'
    },
    switchBase:{
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#4CAF50',
            '& + $track': {
              backgroundColor: '#3E8040',
              opacity: 1,
              border: 'none',
            },
          },
    },
    switchBase2:{
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#ffee58',
            '& + $track': {
              backgroundColor: '#B7A931',
              opacity: 1,
              border: 'none',
            },
          },
    },
    checked:{},
    track: {},
    swithColorPrimary:{
        color: 'yellow'
    }
});





export const ItemIngreso = (props) => {
  const classes = useStyles();
  const {name,tipoDocumentaciones,idCategoria,marcado,idTipoAfiliacion}= props; 
  return (
    <Grid container  item direction="row" justify="center"  lg={12}>
       <Grid  container item direction="row" alignItems="center" justify="center" >
            <Grid item lg={3} sm={2}>
                <Switch checked={marcado}
                name={name}
                onChange={(event)=>props.handleChangeDelete(idCategoria,idTipoAfiliacion,event)}
                value={idCategoria}
                classes={{switchBase:classes.switchBase,checked:classes.checked,track:classes.track}}
                />
            </Grid>
            <Grid item lg={8} sm={8}>
                <Typography className={classes.TypographyRoot} >{tipoDocumentaciones}</Typography>
            </Grid>
        </Grid>
    </Grid>
  );
};
